// const Accordion = () => {
//   const accordionList = [...document.querySelectorAll(".accordion__item")];
// console.log("accordionList", accordionList);
//   if (accordionList.length !== 0 ) {
//     accordionList.forEach((accordionItem) => {
//       const accordionTitle = accordionItem.querySelector(".accordion__title");

//       accordionTitle.addEventListener("click", () => {
//         const existedOpenedItem = accordionList.filter(item => item.classList.contains('opened'))[0];
//         if (existedOpenedItem !== accordionItem) {
//           existedOpenedItem?.classList.remove('opened');
//         }

//         accordionItem.classList.toggle("opened");
//       });
//     })
//   }
// }

// export default Accordion;

const Accordion = () => {
  const items = Array.from(document.querySelectorAll(".accordion__item"));
  if (!items.length) return;

  const onTitleClick = (e) => {
    // e.stopPropagation();
    const title = e.currentTarget;
    const item = title.closest(".accordion__item");
    const container = item.parentElement; 

    Array.from(container.children).forEach((el) => {
      if (el !== item && el.classList && el.classList.contains("accordion__item")) {
        el.classList.remove("opened");
      }
    });
    item.classList.toggle("opened");
  };

  items.forEach((it) => {
    const title = it.querySelector(".accordion__title");
    if (title) title.addEventListener("click", onTitleClick);
  });

  const openAncestorsForLink = (aEl) => {
    let node = aEl.closest(".accordion__item");
    while (node) {
      node.classList.add("opened");
      const container = node.parentElement;
      Array.from(container.children).forEach((el) => {
        if (el !== node && el.classList && el.classList.contains("accordion__item")) {
          el.classList.remove("opened");
        }
      });
      node = container.closest(".accordion__item");
    }
  };
};

export default Accordion;
